import {Component, ContentChild, Input, OnChanges, SimpleChanges, TemplateRef} from '@angular/core';
import {CommonModule} from "@angular/common";
import {LoadingModule} from "../../../../components/common/loading/loading.module";
import {IDefaultService} from "../../service/v2/service/iDefault.service";
import {IActionService} from "../../service/v2/service/action/iaction.service";
import {UserFindByIdService} from "../../../account/modules/user/api/service/userFindById.service";
import {AbstractFindOneByIdService} from "../../service/v2/service/findone/abstractFindOneById.service";
import {ErrorTextModule} from "../error-text/error-text.module";
import {ServiceContainerComponent} from "../service-container/service-container.component";
import {Subscription} from "rxjs";
import {ContentDirective} from "../../../../shared/directives/content.directive";

@Component({
  selector: 'app-service-find-by-id-container',
  templateUrl: './service-find-by-id-container.component.html',
  standalone: true,
  imports: [
    CommonModule,
    LoadingModule,
    ErrorTextModule,
    ServiceContainerComponent,
  ]
})
export class ServiceFindByIdContainerComponent implements OnChanges {

  @Input() service: AbstractFindOneByIdService<any, any>;
  @Input() id: number;
  @Input() loadingMessage: string;
  @Input() errorMessage: string;
  @Input() entityNotFoundText: string;
  @Input() stickyLoading = false;
  @Input() fullHeight = false;

  @ContentChild(ContentDirective, {static: true, read: TemplateRef}) template: TemplateRef<any>;

  entity: any;

  subscriptions: Subscription[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['id'] || changes['service']) {
      this.removeSubscriptions();
      this.subscriptions.push(this.service.entity$.subscribe(value => this.entity = value));
      this.service.loadEntity(this.id);
    }
  }

  constructor() {

  }

  ngOnDestroy(): void {
    this.removeSubscriptions();
  }

  removeSubscriptions() {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }


}
